import { TrendingDown, BadgePercent, Leaf, Clock, ShieldCheck, HeartHandshake } from "lucide-react";

const benefits = [
  {
    icon: TrendingDown,
    title: "Risparmio fino al 90%",
    description: "Riduci la bolletta elettrica fino al 90% grazie all'energia solare autoprodotta con batteria di accumulo.",
    stat: "-90%",
    statLabel: "sulla bolletta",
    accent: "emerald",
    span: "col-span-1 md:col-span-2",
  },
  {
    icon: BadgePercent,
    title: "Detrazioni Fiscali",
    description: "Approfitta delle detrazioni fiscali fino al 50% sull'acquisto e installazione.",
    stat: "50%",
    statLabel: "detrazione",
    accent: "blue",
    span: "col-span-1",
  },
  {
    icon: Leaf,
    title: "100% Energia Verde",
    description: "Contribuisci alla transizione energetica producendo energia pulita e rinnovabile.",
    stat: "0",
    statLabel: "emissioni CO₂",
    accent: "emerald",
    span: "col-span-1",
  },
  {
    icon: Clock,
    title: "Veloce e Semplice",
    description: "Ricevi fino a 5 preventivi gratuiti in poche ore, direttamente da fornitori nella tua zona.",
    stat: "5",
    statLabel: "preventivi gratis",
    accent: "blue",
    span: "col-span-1 md:col-span-2",
  },
  {
    icon: ShieldCheck,
    title: "Garanzia 25 Anni",
    description: "I pannelli fotovoltaici moderni garantiscono performance elevate per oltre 25 anni.",
    stat: "25+",
    statLabel: "anni garanzia",
    accent: "emerald",
    span: "col-span-1",
  },
  {
    icon: HeartHandshake,
    title: "Senza Impegno",
    description: "Il nostro servizio è completamente gratuito e senza alcun obbligo di acquisto.",
    stat: "0€",
    statLabel: "costo servizio",
    accent: "blue",
    span: "col-span-1",
  },
];

const accentStyles = {
  emerald: {
    iconBg: "bg-emerald-50",
    iconColor: "text-emerald-600",
    statColor: "text-emerald-600",
  },
  blue: {
    iconBg: "bg-blue-50",
    iconColor: "text-blue-600",
    statColor: "text-blue-600",
  },
};

export const Benefits = ({ onConfigureClick }) => {
  return (
    <section id="vantaggi" className="py-20 sm:py-28 bg-slate-50" data-testid="benefits-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-left max-w-xl mb-16">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wide">I Vantaggi</span>
          <h2
            className="mt-3 text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="benefits-title"
          >
            Perché scegliere il<br />fotovoltaico con noi
          </h2>
          <p className="mt-4 text-slate-500 text-base sm:text-lg">
            Investire nel solare non è mai stato così semplice e conveniente.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 lg:gap-6">
          {benefits.map((b, i) => {
            const styles = accentStyles[b.accent];
            return (
              <div
                key={b.title}
                className={`${b.span} bento-item bg-white rounded-2xl border border-slate-100 p-6 sm:p-8`}
                style={{ animationDelay: `${i * 100}ms` }}
                data-testid={`benefit-card-${i}`}
              >
                <div className="flex items-start justify-between mb-4">
                  <div className={`w-12 h-12 rounded-xl ${styles.iconBg} flex items-center justify-center`}>
                    <b.icon className={`w-6 h-6 ${styles.iconColor}`} strokeWidth={1.5} />
                  </div>
                  <div className="text-right">
                    <div className={`text-2xl sm:text-3xl font-bold ${styles.statColor} stat-number`} style={{ fontFamily: "Outfit, sans-serif" }}>
                      {b.stat}
                    </div>
                    <div className="text-xs text-slate-400">{b.statLabel}</div>
                  </div>
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2" style={{ fontFamily: "Outfit, sans-serif" }}>{b.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed">{b.description}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={onConfigureClick}
            className="bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-full px-8 py-3.5 text-base btn-scale shadow-lg shadow-emerald-500/25"
            data-testid="benefits-cta"
          >
            Inizia il Tuo Preventivo Gratuito
          </button>
        </div>
      </div>
    </section>
  );
};
